import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { sortBy } from '../../../lib/utils/sort-by';
import { SettingsTable } from '../../../components/settings-table/settings-table';
import { InvitationItem } from './invitation-item';
import { PagePlaceholder } from '../../../components/page-placeholder/page-placeholder';

import type { Space } from '../../../app/entities';

type InvitationsTabProps = {
  space: Space;
};

const tableHeaders = ['Email', 'Role', 'Invited at'];

export const InvitationsTab: React.FC<InvitationsTabProps> = observer(({ space }) => {
  const sortedByLatest = useMemo(
    () => sortBy(space.invitations, 'invitedAt', 'desc'),
    [space.invitations],
  );

  const hasInvitations = !!sortedByLatest?.length;

  return (
    <SettingsTable headers={tableHeaders} isFullHeight={!hasInvitations}>
      {hasInvitations ? (
        sortedByLatest?.map((invitation) => (
          <InvitationItem key={invitation?._id} invitation={invitation} />
        ))
      ) : (
        <PagePlaceholder description="Invitations will be displayed here" />
      )}
    </SettingsTable>
  );
});
